Vue.component('card-backs', {
  template: templates.cardBacks,
  data() {
    return {
      model: {
        edit: false,
        back: {
          id: null,
          name: null,
          description: null,
          rarity: 'standard',
          point_cost: 0,
          active: false,
          available_shop: false,
          available_store: false,
          available_packs: false,
          available_chest: false,
          available_reward: false,
          image: null
        },
        backs: {}
      }
    };
  },
  watch: {
    'model.back.image': function () {
      this.$forceUpdate();
    }
  },
  mounted() {
    const c = this;
    c.get();

    c.$root.$on('remove-existing-image', () => {
      c.model.back.image = null;
    });
  },
  methods: {
    get() {
      const c = this;
      let data = {};

      cardBackService.get()
        .then(function (response) {
          for (let d of response.data) {
            d.image = [`${d.id}.png`];
            data[`${d.id}`] = d;
          }
          c.model.backs = data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    add() {
      const c = this;
      c.reset();
      c.model.edit = true;
    },

    edit(id) {
      const c = this;
      const data = c.model.backs[`${id}`];

      if (id == c.model.back.id) {
        c.model.edit = false;
        return;
      }

      c.model.edit = true;
      c.model.back = {
        id: data.id,
        name: data.name,
        description: data.description,
        rarity: data.rarity || 'standard',
        point_cost: data.point_cost || 0,
        active: !!data.active,
        available_shop: !!data.available_shop,
        available_store: !!data.available_store,
        available_packs: !!data.available_packs,
        available_chest: !!data.available_chest,
        available_reward: !!data.available_reward,
        image: data.image
      };
    },

    save() {
      const c = this;
      const data = c.model.back;

      if (!data.name) {
        utils.alert.error('Name is required.');
        return;
      }

      cardBackService.save(data)
        .then(function (response) {
          if (data.id) {
            c.model.backs[`${data.id}`] = Object.assign({}, data);
          } else {
            data.id = response.data.id;
            data.image = [`${data.id}.png`];
            c.model.backs[`${data.id}`] = Object.assign({}, data);
          }
          utils.alert.success('Saved!');
          c.$forceUpdate();
        })
        .catch(function () {
          utils.alert.error('Failed to save.');
        });
    },

    remove(id) {
      if (!confirm('Delete this card backing? This cannot be undone.')) {
        return;
      }

      const c = this;
      const data = c.model.backs[`${id}`];
      data.deleted = true;

      cardBackService.save(data)
        .then(function () {
          delete c.model.backs[`${id}`];
          if (c.model.back.id == id) {
            c.reset();
          }
          utils.alert.success('Deleted!');
          c.$forceUpdate();
        })
        .catch(function () {
          utils.alert.error('Failed to delete.');
        });
    },

    reset() {
      const c = this;
      c.model.edit = false;
      c.model.back = {
        id: null,
        name: null,
        description: null,
        rarity: 'standard',
        point_cost: 0,
        active: false,
        available_shop: false,
        available_store: false,
        available_packs: false,
        available_chest: false,
        available_reward: false,
        image: null
      };
    },

    getBackUrl() {
      return `${root}/images/card-backs/`;
    },

    handleImageUpload(data) {
      const c = this;
      if (data && data.files && data.files.length > 0) {
        const backImage = [`${c.model.back.id}.png?t=${Date.now()}`];
        c.model.back.image = backImage;
        if (c.model.backs[`${c.model.back.id}`]) {
          Vue.set(c.model.backs[`${c.model.back.id}`], 'image', backImage);
        }
        utils.alert.success('Image uploaded!');
        c.$forceUpdate();
      }
    }
  }
});
